// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { z } from 'zod';
import { INVERSIS_KYC_ANSWER_OPTIONS } from './inversis-id-map';

export const accountUsageSchema = z
  .object({
    accountPurpose: z
      .array(z.string().min(1, 'Account purpose is required'))
      .min(1, 'Select at least one account purpose'),
    monthlyOperations: z.string().min(1, 'Monthly operations are required'),
    monthlyTransfers: z.string().min(1, 'Monthly transfers are required'),
    accountCheques: z.string().min(1, 'Cheques operation selection is required'),
  })
  .check(({ value, issues }) => {
    const data = value;

    for (const [index, purpose] of data.accountPurpose.entries()) {
      const key = `ACCOUNT_PURPOSE.${purpose}`;

      if (!INVERSIS_KYC_ANSWER_OPTIONS.has(key)) {
        issues.push({
          code: 'custom',
          input: purpose,
          path: ['accountPurpose', index],
          message: 'Invalid account purpose option',
        });
      }
    }

    const monthlyOpsKey = `MONTHLY_OPS.${data.monthlyOperations}`;

    if (!INVERSIS_KYC_ANSWER_OPTIONS.has(monthlyOpsKey)) {
      issues.push({
        code: 'custom',
        input: data.monthlyOperations,
        path: ['monthlyOperations'],
        message: 'Invalid monthly operations option',
      });
    }

    const monthlyTransfersKey = `MONTHLY_TRANSFERS.${data.monthlyTransfers}`;

    if (!INVERSIS_KYC_ANSWER_OPTIONS.has(monthlyTransfersKey)) {
      issues.push({
        code: 'custom',
        input: data.monthlyTransfers,
        path: ['monthlyTransfers'],
        message: 'Invalid monthly transfers option',
      });
    }

    const chequesKey = `ACCOUNT_CHEQUES.${data.accountCheques}`;

    if (!INVERSIS_KYC_ANSWER_OPTIONS.has(chequesKey)) {
      issues.push({
        code: 'custom',
        input: data.accountCheques,
        path: ['accountCheques'],
        message: 'Invalid account cheques option',
      });
    }
  });

export type AccountUsageFormData = z.infer<typeof accountUsageSchema>;
